import { UNIVERSES } from "./content";

export default function Marquee({ lang }) {
  const names = UNIVERSES.map((u) => (lang === "fr" ? u.nameFr : u.nameEn));
  const seq = [...names, ...names];
  return (
    <div className="marquee" data-testid="marquee" aria-hidden="true">
      <div className="marquee__track">
        {seq.map((n, i) => (
          <span className="marquee__item" key={i}>
            {n}
            <i className="diamond" />
          </span>
        ))}
      </div>
    </div>
  );
}
